import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { getTemperature } from '../../../../../../helper/temperature';

@Component({
  selector: 'app-p00043-card-pac-controle',
  templateUrl: './p00043-card-pac-controle.component.html',
  styleUrls: ['./p00043-card-pac-controle.component.scss'],
  imports: [LargedTuileComponent, TranslatePipe],
})
export class P00043CardPacControleComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];
  public buttonMode: TuileButtonProps[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttonMode = [
      {
        title: 'P00043.dashboard.card.status.off',
        icon: 'off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P00043.dashboard.card.status.on',
        icon: 'on',
        color: 'color-green',
        status: 'active',
      },
    ];

    this.buttons = [
      {
        title: 'P00043.control.modeFonctionnement.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
      },
      {
        title: 'P00043.control.modeFonctionnement.horloge',
        icon: 'fa-kit fa-picto-horloge',
        color: 'color-orange',
      },
      {
        title: 'P00043.control.modeFonctionnement.regulation',
        icon: 'fa-kit fa-picto-programme',
        color: 'color-orange',
      },
      {
        title: 'P00043.control.modeFonctionnement.on',
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.PAC,
      FunctionOnglet.PARAMETRE_REGLAGE,
      this.actionStack!.getValue('paPModeRegulation') === 0
        ? this.translateService.instant('P00043.dashboard.card.title.warm')
        : this.translateService.instant('P00043.dashboard.card.title.cold'),
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly getTemperature = getTemperature;
}
